import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {MessageChatSquareIcon} from '@/components/ui/icon/Icon'
import {StyledEmptyConversationStateContainer, StyledEmptyConversationStateIcon} from './style.ts'
import {Text} from '@/components/ui/text/Text'

interface EmptyConversationStateProps {
    messageKey?: string
    icon?: React.ReactNode
}

const EmptyConversationStateComponent = ({
    messageKey = 'conversations:no_messages',
    icon
}: EmptyConversationStateProps) => {
    const {t} = useTranslation()

    return (
        <StyledEmptyConversationStateContainer direction="column" align="center" justify="center">
            <StyledEmptyConversationStateIcon>
                {icon || <MessageChatSquareIcon size={48} />}
            </StyledEmptyConversationStateIcon>
            <Text size="textLg" palette="neutral" shade="400">
                {t(messageKey)}
            </Text>
        </StyledEmptyConversationStateContainer>
    )
}

export const EmptyConversationState = memo(EmptyConversationStateComponent)
